<div *showAuthed="true" id="addcomment">
  <div class="card trnasiction-card">
    <div class="card-header bg-c-blue">
      <h5 class="text-white">
        <span class="d-block text-center">Upload image</span>
      </h5>
    </div>
    <div class="card-block text-center">
      <!-- Uploaded image start -->
      <div class="col">
        <div class="text-center">
          <!-- Uploaded image start -->
          <div *ngIf="downloadURL; let downloadSrc">
            <a class="media-middle" [href]="downloadSrc" target="_blank">
              <img
                style="border: 4px solid #2ed8b6"
                class="uploaded-image"
                [src]="downloadSrc"
                alt="uploaded-image"
              />
            </a>
          </div>

          <div
            *ngIf="!task"
            style="margin: auto; margin-top: 10px"
            class="d-flex justify-content-center uploaded-image"
          >
            <span style="margin: auto" class="fa fa-camera f-50 text-primary">
            </span>
          </div>
        </div>
      </div>
      <!-- Uploaded image end -->

      <div *ngIf="downloadURL; let downloadSrc">
        <div class="alert alert-success icons-alert">
          <button
            style="margin: auto"
            type="button"
            class="close"
            appRemoveAlert
          >
            <i class="icofont icofont-close-line-circled"></i>
          </button>
          <p>
            <strong>File uploaded!</strong>
            <a [href]="downloadSrc" target="_blank">
              {{ downloadSrc | slice: 0:30 }}
            </a>
          </p>
          <p></p>
        </div>
      </div>

      <div class="col-12" style="margin-top: 10px">
        <div class="progress">
          <div
            class="progress-bar progress-bar-success"
            role="progressbar"
            [style.width]="uploadProgress + '%'"
            aria-valuenow="(uploadProgress )"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    </div>

    <div class="b-t-default">
      <div class="col-12 b-r-default">
        <label class="custom-file-upload">
          <input type="file" (change)="upload($event)" accept=".png,.jpg" />
        </label>
      </div>
    </div>

    <div class="b-t-default transection-footer row">
      <div *ngIf="downloadURL" class="col-12">
        <button
          style="width: 100%"
          type="button"
          class="btn btn-primary"
          (click)="save()"
        >
          <div class="row">
            <div style="margin: auto">
              <i class="icofont icofont-cloud-upload"></i>
              <span> Save </span>
            </div>
          </div>
          <!-- Content marker -->
          <ng-content></ng-content>
        </button>
      </div>
    </div>
  </div>
</div>
